import 'leaflet/dist/leaflet.css';
import { MapContainer } from 'react-leaflet';
import styled from 'styled-components';
import { Select } from 'antd';
import { Theme } from 'utils/color/horizonTheme';

export const StyledMap = styled(MapContainer)<{ height?: string }>`
  width: 100%;
  height: ${props => (props.height ? props.height : '100%')};
  z-index: 1;
  position: relative;

  .custom-tooltip {
    background-color: none;
    border-color: none;
    background: none;
    border: none;
    box-shadow: none;
    margin: 12px 0 0 0;
    cursor: default;

    &:before {
      display: none;
    }
  }

  & .marker-cluster-small {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-small div {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-medium {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-medium div {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-large {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-large div {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  ${({ theme }) =>
    theme.themeName === Theme.Dark &&
    `
    .leaflet-popup-content-wrapper,
    .leaflet-popup-tip,
    .leaflet-control-layers {
      background-color: ${theme.tooltipBackground};
      color: ${theme.headerColor};
    }

    .leaflet-control-zoom-in,
    .leaflet-control-zoom-out {
      background-color: ${theme.buttonBackgroundColor};
      color: ${theme.headerColor};

      &:hover {
        background-color: ${theme.secondaryBackgroundColor};
      }

      &.leaflet-disabled {
        background-color: ${theme.disabledBackground};
        color: ${theme.disabledTextColor};
        cursor: not-allowed;
      }
    }
  `}
`;

export const StyledSelect = styled(Select)`
  z-index: 1000;
  position: absolute !important;
  right: 0;
  margin: 0.25rem !important;
`;

// This text renders directly on the map and should always be black, not themed
export const StyledText = styled.p`
  color: #000000;
  font-size: 20px;
  font-weight: 700;
`;
